export default __webpack_public_path__ + "arrow-pointing-to-left.png";